export enum ProductGroupRotation {
	Front = 'front',
	Side = 'side',
	// TODO: check if this can be removed
    FrontRotated = 'front-rotated', // TODO: need to delete after deploy new product position
	FrontRotatedRight = 'front-rotated-right',
    FrontRotatedLeft = 'front-rotated-left',
	Top = 'top'
}